import React from "react";

export default function DocIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="2"
        y="1"
        width="10"
        height="12"
        rx="1.5"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <line
        x1="4"
        y1="5"
        x2="10"
        y2="5"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <line
        x1="4"
        y1="7.5"
        x2="10"
        y2="7.5"
        stroke="currentColor"
        strokeWidth="1.1"
      />
    </svg>
  );
}
